import { render, staticRenderFns } from "./showWindow.vue?vue&type=template&id=1d64c6fc"
import script from "./showWindow.vue?vue&type=script&lang=js"
export * from "./showWindow.vue?vue&type=script&lang=js"
import style0 from "./showWindow.vue?vue&type=style&index=0&id=1d64c6fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports